import React from 'react';
import { useTranslation } from 'react-i18next';
import TopServicesByVolume from '../panels/TopServicesByVolume';
import HitRateByService from '../panels/HitRateByService';
import HitVsMissChart from '../panels/HitVsMissChart';
import RequestsByWorkspacePanel from '../panels/RequestsByWorkspacePanel';
import IdleServicesPanel from '../panels/IdleServicesPanel';
import LocationUtilisationPanel from '../panels/LocationUtilisationPanel';
import { RoiInsightsData } from '../types';

interface Props {
  data: RoiInsightsData;
}

const StatisticsSection: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation('admin');
  return (
    <section className="roi-section statistics-section">
      <h2 className="roi-section-title">{t('roiInsights.statistics.title')}</h2>
      <p className="roi-section-subtitle">{t('roiInsights.statistics.subtitle')}</p>
      <div className="roi-stats-grid">
        <TopServicesByVolume services={data.topByVolume} />
        <HitRateByService services={data.topByHitRate} />
        <HitVsMissChart services={data.hitMissBreakdown} />
        <RequestsByWorkspacePanel workspaces={data.workspaceRequests} />
        <IdleServicesPanel entries={data.idleCandidates} />
        <LocationUtilisationPanel locations={data.locationUtilisation} />
      </div>
    </section>
  );
};

export default StatisticsSection;
